import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const RouteScheduleItemDisplayStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "contact-item-display",
  },
)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 8px 16px;

  .route-schedule-item-display__content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .route-schedule-item-display__row {
    display: grid;
    grid-template-columns: 110px 1fr;
    align-items: center;
    column-gap: 8px;

    label {
      color: ${greyMui._600};
      line-height: 1.8;
      font-weight: 400;
    }

    > div,
    p {
      margin: 0;
      line-height: 1.8;
      color: ${greyMui._900};
    }
  }

  .route-schedule-item-display__actions {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }
`;
